// Additional polyfills
import 'custom-event-polyfill'
import 'url-polyfill'
// Core
import Vue from 'vue'
import App from './App'
import router from './router'

// Helpers
import _ from 'lodash'

// Misc
import globals from './globals'
import Popper from 'popper.js'

// Filters
import numericFilters from './filters/numerics'

// Components
import BootstrapVue from 'bootstrap-vue'
import LaddaBtn from '@/vendor/libs/ladda/Ladda'
import Multiselect from 'vue-multiselect'

import http from './http'
import store from './store'
import config from './config'

/* ***************
 * VEE-VALIDATE
 * ***************/
import { ValidationProvider, extend, ValidationObserver, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import es from 'vee-validate/dist/locale/es.json'

import moment from 'moment'
// moment.tz.setDefault('America/Argentina')
moment.locale('es')
Vue.prototype.$moment = moment

localize('es', es)

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule])
})
Vue.component('LaddaBtn', LaddaBtn)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('Multiselect', Multiselect)

Vue.prototype.image_path = process.env.VUE_APP_IMAGE_URL
Vue.prototype.api_url = process.env.VUE_APP_IMAGE_URL
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false
Vue.config.productionTip = false

Vue.use(BootstrapVue)

// Global RTL flag
Vue.mixin({
    data: globals
})

// Filters
Object.keys(numericFilters).forEach(key => Vue.filter(key, numericFilters[key]))

Vue.prototype.$eventHub = new Vue()
Vue.prototype._ = _

// Set Front Version
const currentVersion = process.env.VUE_APP_VERSION || 'dev'
store.commit('setPackageVersion', currentVersion)

if (process.env.NODE_ENV === 'production') {
    const baseUrl = process.env.BASE_URL || '/'
    const VERSION_CHECK_INTERVAL = 5 * 60 * 1000

    const checkForUpdates = async () => {
        if (typeof window.fetch !== 'function') {
            return
        }

        try {
            const response = await fetch(`${baseUrl}version.json?cacheBust=${Date.now()}`, {
                cache: 'no-store',
                headers: {
                    'cache-control': 'no-store'
                }
            })

            if (!response.ok) {
                return
            }

            const payload = await response.json()

            if (payload.version && payload.version !== currentVersion) {
                window.location.reload()
            }
        } catch (error) {
            // Ignore network errors and retry on next interval
        }
    }

    setInterval(checkForUpdates, VERSION_CHECK_INTERVAL)
    window.addEventListener('focus', checkForUpdates)
    checkForUpdates()
}

new Vue({
    http: http,
    store: store,
    router: router,
    config: config,
    render: h => h(App)
}).$mount('#app')
